module.exports = __webpack_public_path__ + "static/images/vn.3JUoOeq.svg";